import { useAuthStore } from '../store/auth';
// import axios from './axios';
// import { jwtDecode as jwt_decode } from 'jwt-decode';
// import Cookies from 'js-cookie';
// import { useSharedData } from '../components/setdata.js';
import { setAuthUser, setAuthUserToStore, getRefreshToken, isAccessTokenExpired } from '../utils/auth'
import Cookies from 'js-cookie';


function useSetUser() {
    const { setCSRFToken, setAccessToken, setRefreshToken } = useAuthStore();
    const accessToken = useAuthStore((state) => state.getAccessToken());

    const setUser = async () => {
        // ON PAGE LOAD
        // If we already hold a valid, unexpired access token in memory, use it.
        if (accessToken && !isAccessTokenExpired(accessToken)) {
            setAccessToken(accessToken);
            setAuthUserToStore(accessToken);
            return;
        }
        // Otherwise (no in-memory token, e.g. after a full page reload, or an
        // expired one) try to recover the session from the HttpOnly refresh
        // cookie. Only attempt if the cookie exists — avoids a guaranteed 400
        // on every page load for unauthenticated visitors.
        if (!Cookies.get('refresh_token')) return;
        const response = await getRefreshToken();
        if (response?.access) {
            setAccessToken(response.access);
            setAuthUserToStore(response.access);
        }
    };

    return { setUser };
};

export default useSetUser;